import { c as _c } from "react/compiler-runtime";
import useAppElement from '@/contexts/appContext/hooks/useAppElement';
/* eslint-disable-next-line */
import { Tooltip as LibTooltip } from '@winelidays/wld-tsx-2/modules';
const Tooltip = props => {
    const $ = _c(3);
    const appElement = useAppElement();
    let t0;
    if ($[0] !== appElement || $[1] !== props) {
        t0 = <LibTooltip appendTo={appElement} {...props}/>;
        $[0] = appElement;
        $[1] = props;
        $[2] = t0;
    }
    else {
        t0 = $[2];
    }
    return t0;
};
export default Tooltip;
